import React, { useEffect, useState } from 'react';
import ApiService from '../Services/ApiService';

const useGetUsuarioLogeado = () => {
    const { REACT_APP_APIPAYWALL } = process.env;
    const [isLoading, setIsLoading] = useState(null);
    const [usuarioLogeado, setUsuarioLogeado] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            setIsLoading(true);
            return ApiService.get(`${REACT_APP_APIPAYWALL}Cliente/UsuarioLogeado`)
                .then((data) => {
                    if (data && data.code === '0000') {
                        setUsuarioLogeado(data.response);
                        setIsLoading(false);
                    } else {
                        setError(data.message);
                        setIsLoading(false);
                    }
                })
                .catch((error) => {
                    setError(error);
                    setIsLoading(false);
                });
        };
        
        fetchData()
    }, [])
    

    return {usuarioLogeado, isLoading, error};
};

export default useGetUsuarioLogeado;